export default __webpack_public_path__ + "static/media/RssSimple_2.0809a136.svg";